import $foreign from "./foreign.cjs";
var eqArrayImpl = $foreign.eqArrayImpl;
var eqBooleanImpl = $foreign.eqBooleanImpl;
var eqCharImpl = $foreign.eqCharImpl;
var eqIntImpl = $foreign.eqIntImpl;
var eqNumberImpl = $foreign.eqNumberImpl;
var eqStringImpl = $foreign.eqStringImpl;
export { eqArrayImpl, eqBooleanImpl, eqCharImpl, eqIntImpl, eqNumberImpl, eqStringImpl };
